export default {
  headerDetails: "Détails du produit",
  "headerSign In": "Se connecter",
  headerSettings: "Paramètres",
  headertransaction: "Commandes",
  signin: "Se connecter",
  signinReq: "* Indique un champ obligatoire",
  emailReq:"E-mail*",
  passwordReq:"Mot de passe*",
  newTo: "Nouveau sur CalmPurr ?",
  createAccount: "Créer un compte",
  firstName: "Prénom*",
  lastName: "Nom*",
  streetaddress: "Adresse*",
  state: "Région*",
  city: "Ville*",
  zip: "Code postal*",
  phone: "Téléphone*",
  country: "Pays*",
  done: "Terminé",
  categoryPopular: "Populaire",
  categoryCustom: "Personnalisation photo",
  categoryFat: "Chat dodu",
  categorySlim: "Chat mince",
  categoryMini: "Mini chat",
  freeShippingTips: "Livraison gratuite dans le monde entier sur toutes les commandes !",
  alreadyHaveAccount: "Vous avez déjà un compte ?",
  code: "Code",
  bestseller: "Meilleures ventes",
  recommendforyou: "Recommandé pour vous",
  ourcustomershow: "Photos des clients",
  faq: "FAQ",
  faq1: "Livrez-vous à l'international ?",
  faq1answer: "Oui ! Nous livrons dans plus de 90 pays. Pour vérifier la disponibilité dans votre région, entrez simplement votre adresse lors du paiement. Nous élargissons constamment nos services de livraison internationale✈️",
  faq2: "Quel est le délai de livraison ?",
  faq2answer: "Selon votre région, la livraison standard prend environ 6 à 10 jours ouvrables. Les articles personnalisés nécessitent 3 à 7 jours supplémentaires de production. Vous recevrez un e-mail avec le numéro de suivi une fois votre commande expédiée.💖",
  faq3:"Comment suivre ma commande ?",
  faq3answer: "Après l’expédition, vous trouverez votre numéro de suivi et les informations en temps réel sur votre page Détails de la commande.",
  faq4:"De quoi est-il fait ? Est-ce sûr ?",
  faq4answer: "Nos squishies CalmPurr sont fabriqués en silicone de qualité alimentaire — doux, sûr, non toxique et agréable au toucher.",
  faq5:"Est-ce solide ? Peut-il se casser facilement ?",
  faq5answer: "Nos squishies sont très résistants et peuvent être pressés de nombreuses fois ! Nous recommandons de les garder dans leur emballage d'origine pour préserver leur forme et leur qualité.",
  review1: "Je l’adore tellement ! L’emballage était également très soigné. Hâte de l’exposer dans un endroit spécial !",
  review2: "Squishy super mignon, excellente qualité ! Livré avec une petite pochette adorable 😍",
  review3: "Cela a pris du temps mais ça valait vraiment le coup. Une réplique parfaite d’un chat du Bengale — magnifique ! 😍",
  review4: "Je ne m’attendais pas à autant de poils, mais honnêtement je m’en fiche, IL EST TROP MIGNON ! Parfait comme jouet anti-stress !",
  review5: "Super mignon et très qualitatif. Je ne pensais pas qu’il serait aussi bien fait !",
  review6: "J’ai perdu mon chat en janvier et j’ai commandé ce squishy à son image… cela m’a vraiment aidé.",
  review7: "C’était un cadeau pour une amie géniale 💓 — arrivé en parfait état, 100% satisfait !",
  review8: "J’adore mon chat ! Livraison rapide et joli panier inclus ! Je pense en commander un autre bientôt. Merci Bambi !",
  aboutus:"À propos",
  contactus: "Nous contacter",
  privacypolicy: "Politique de confidentialité",
  terms: "Conditions générales",
  returnpolicy: "Politique de retour",
  footertitle: "Chats en silicone faits à la main",
  home: "Accueil",
  shoppingcart: "Panier",
  orderhistory: "Historique des commandes",
  settings: "Paramètres",
  youshippinginfo: "Vos informations d’expédition",
  shipping: "Livraison",
  payment: "Paiement",
  apply: "Appliquer",
  description: "Description",
  shippingInfo: "Informations sur la livraison",
  buyText: "Acheter",
  addtocart: "Ajouté au panier !",
  thankyou: "Merci",
  yoursavings: "Vos économies",
  shippingInfoDetail: "Livraison gratuite. Expédition dans le monde entier.",
  cartisempty: "Votre panier est vide",
  continueshopping: "Continuer vos achats",
  itemtotal: "Sous-total",
  freeshipping: "Livraison gratuite",
  ordertotal: "Total",
  notorderyet: "Vous n’avez encore passé aucune commande.",
  shopnow: "Acheter maintenant",
  changeemail: "Changer l’e-mail",
  changepass: "Changer le mot de passe",
  logout: "Se déconnecter",
  changeemailtips: "Utilisez ce formulaire pour modifier votre adresse e-mail.",
  currentemail: "E-mail actuel",
  newemail: "Nouvel e-mail",
  confirmemail: "Confirmer l’e-mail",
  enteremail: "Saisir l’e-mail",
  enterconfirmemail: "Confirmer le nouvel e-mail",
  couponoff5title: "5% DE RÉDUCTION",
  couponoff5desc: "Commandes à partir de 50 €",
  couponoff10title: "10% DE RÉDUCTION",
  couponoff10desc: "Commandes à partir de 60 €",
  couponoff15title: "15% DE RÉDUCTION",
  couponoff15desc: "Commandes à partir de 80 €",
  contactemail: "Veuillez entrer votre e-mail*",
  contactsubject: "Sujet*",
  contactDesc: "Description*",
  areyousure: "Êtes-vous sûr ?",
  cancelshipping: "Voulez-vous annuler la saisie de vos informations de livraison ?",
  enterpromotioncode: "Saisir le code promo",
  removeItemTips: "Retirer cet article du panier ?",
  removeItem: "Retirer l’article",
  cancel: "Annuler",
  placeorder: "Passer la commande",
  currencyChangeTips: "À titre indicatif. Le règlement s'effectue en Euro (€).",
  selectCurrency: "Sélectionner la devise",
  approx: "Env.",
  specialOffer: "Offre spéciale",
  christmasOffer: "Offre spéciale Nouvel An 2026",
  christmasOfferCopy: "Cliquez sur le code ci-dessous pour le copier",
  christmasOfferCondition: "Commande supérieure à 50 €",
};



// WEBPACK FOOTER //
// ./src/lang/fr.js